import AlertsContainer from "./AlertsContainer";

export default AlertsContainer;
